import { orchestrator } from 'satcheljs';
import { initializeArchiveMailboxFromSessionData } from '../actions/publicActions';
import { setMailboxData } from '../actions/internalActions';
import Folder from '../store/schema/Folder';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from '../util/folderConstants';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';

/**
 * An orchestrator that initializes the archive root folder with session data.
 */
export default orchestrator(initializeArchiveMailboxFromSessionData, () => {
    const sessionSettings = getUserConfiguration().SessionSettings;
    if (!sessionSettings.HasArchive) {
        return;
    }

    // Initialize the archive root folder using the data received in session data such as display name and set it in the store.
    const folder: Folder = {
        distinguishedFolderId: ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        isHidden: false,
        DisplayName: sessionSettings.ArchiveDisplayName,
    };

    // update the archive mailbox root and loading state.
    setMailboxData(
        ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        folder,
        MailboxLoadStateEnum.Uninitialized
    );
});
